import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "pdf-viewer" }
const _hoisted_2 = {
  id: "pdf-page-container",
  ref: "pdfPageContainer"
}
const _hoisted_3 = {
  id: "viewer",
  class: "pdfViewer",
  ref: "viewer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_toolbar = _resolveComponent("pdf-toolbar")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_pdf_toolbar, {
      onPrevPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pdfViewer.currentPageNumber--)),
      onNextPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pdfViewer.currentPageNumber++)),
      onSearch: _ctx.search,
      onSearchReverse: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search($event, true))),
      onPrint: _ctx.print,
      onExpand: _ctx.expand
    }, null, 8 /* PROPS */, ["onSearch", "onPrint", "onExpand"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, null, 512 /* NEED_PATCH */)
    ], 512 /* NEED_PATCH */)
  ]))
}